"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { Button } from "@/components/ui/button"
import { Calculator, Search, FileText, HelpCircle } from "lucide-react"

export function Sidebar() {
  const pathname = usePathname()

  return (
    <aside className="w-64 bg-sidebar border-r border-sidebar-border p-4 flex flex-col">
      <nav className="space-y-2 flex-1">
        <Link href="/calculator">
          <Button variant={pathname === "/calculator" ? "default" : "ghost"} className="w-full justify-start" size="sm">
            <Calculator className="h-4 w-4 mr-2" />
            DLOM & Blockage Calculator
          </Button>
        </Link>

        <Link href="/ticker-lookup">
          <Button
            variant={pathname === "/ticker-lookup" ? "default" : "ghost"}
            className="w-full justify-start"
            size="sm"
          >
            <Search className="h-4 w-4 mr-2" />
            Ticker Lookup
          </Button>
        </Link>

        <Link href="/documentation">
          <Button
            variant={pathname === "/documentation" ? "default" : "ghost"}
            className="w-full justify-start"
            size="sm"
          >
            <FileText className="h-4 w-4 mr-2" />
            Documentation
          </Button>
        </Link>

        <Link href="/support">
          <Button variant={pathname === "/support" ? "default" : "ghost"} className="w-full justify-start" size="sm">
            <HelpCircle className="h-4 w-4 mr-2" />
            Help & Support
          </Button>
        </Link>
      </nav>
    </aside>
  )
}
